<template>
  <div class="comp-migration-detail-drawer">
    <jw-drawer
      width="100%"
      :visible="visible"
      :mask="false"
      :footer="false"
      :header="true"
      unmountOnClose
      @cancel="handleCancel"
      :drawer-style="{
        backgroundColor: 'var(--color-fill-2)',
        boxShadow: '0 1px 3px rgba(0,0,0,.3)'
      }"
    >
      <template #header>
        <div class="header">
          <span class="title">{{ tenantName }}</span>
          <jw-space>
            <jw-tooltip position="bottom" :content="$t('刷新')">
              <jw-button size="large" class="activeIcon" @click="handleRefresh">
                <template #icon>
                  <icon-refresh />
                </template>
              </jw-button>
            </jw-tooltip>
            <jw-tooltip position="bottom" :content="$t('关闭')">
              <jw-button @click="handleCancel" class="activeIcon">
                <template #icon>
                  <icon-close />
                </template>
              </jw-button>
            </jw-tooltip>
          </jw-space>
        </div>
      </template>
      <div class="detail-content">
        <jw-card class="step-card">
          <jw-steps label-placement="vertical" changeable :current="currentStep" @change="handleStepChange">
            <jw-step>数据导出</jw-step>
            <jw-step :disabled="!migrationStatus?.importEnable">数据导入</jw-step>
          </jw-steps>
        </jw-card>
        <div class="detail-export" v-if="currentStep === 1">
          <jw-card title="全部">
            <template #extra>
              <jw-button type="primary" :disabled="!migrationStatus?.exportPartEnable" @click="handleExportAll">一键开启导出</jw-button>
            </template>
            <common-table :entity="params.entity" :type="currentStep" :columns="exportColumns" :data="exportTableData" :loading="isTableLoading"> </common-table>
          </jw-card>
        </div>
        <div class="detail-import" v-if="currentStep === 2">
          <jw-card :title="isNewVersion ? '配置类' : '第一部分'">
            <template #extra>
              <jw-button type="primary" :disabled="!migrationStatus?.importPart1Enable" @click="() => handleImportAll(1)">一键开启导入</jw-button>
            </template>
            <common-table :entity="params.entity" :type="currentStep" :columns="importColumns" :data="importTableData1" :loading="isTableLoading"> </common-table>
          </jw-card>
          <jw-card title="第二部分" v-if="!isNewVersion">
            <template #extra>
              <jw-button type="primary" :disabled="!migrationStatus?.importPart2Enable" @click="() => handleImportAll(2)">确认台账已导入</jw-button>
            </template>
            <div class="import-tips">请在确认 CSM 已导入租户的合同台账后，再导入第三部分数据</div>
          </jw-card>
          <jw-card :title="isNewVersion ? '数据类' : '第三部分'">
            <template #extra>
              <jw-button type="primary" :disabled="!migrationStatus?.importPart3Enable" @click="() => handleImportAll(3)">一键开启导入</jw-button>
            </template>
            <common-table :entity="params.entity" :type="currentStep" :columns="importColumns" :data="importTableData3" :loading="isTableLoading"> </common-table>
          </jw-card>
        </div>
      </div>
    </jw-drawer>
  </div>
</template>

<script setup>
// TAG: 迁移工具
import { ref, toRefs, onMounted, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useMigrationToolsStore } from '@/store';
import { useEnvConfig } from '@/hooks/env-config';
import useColumns from '../../hooks/useColumns';
import useActions from '../../hooks/useActions';
import CommonTable from '../common-table/common-table.vue';

// props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  params: {
    type: String,
    default: ''
  }
});
// emits
const emits = defineEmits(['close']);

// =====data=====
const currentStep = ref(1);

const { visible, params } = toRefs(props);
const { importColumns, exportColumns } = useColumns();

const migrationToolsStore = useMigrationToolsStore();
const { isTableLoading, exportTableData, importTableData1, importTableData3, migrationStatus } = storeToRefs(migrationToolsStore);

const { fieldMappings } = useEnvConfig(props.params.entity);
const tenantId = params.value.row[fieldMappings.tenantId];
const tenantName = params.value.row[fieldMappings.tenantName];
migrationToolsStore.setTenantId(tenantId);

const isNewVersion = computed(() => {
  return migrationStatus?.value?.version >= 7;
});

const { handleRefresh, getDataList, handleExportAll, handleImportAll } = useActions({ currentStep });

// =====mounted=====
onMounted(() => {
  handleRefresh();
});

// =====methods=====
// step切换
const handleStepChange = (val) => {
  currentStep.value = val;
  getDataList();
};
// 弹窗关闭
const handleCancel = () => {
  emits('close');
};
</script>
<style scoped lang="less">
@import './migration-detail-drawer.less';
</style>
